export const blendWithWhite = (hex: string, ratio: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const blend = (channel: number) => Math.round(255 + (channel - 255) * ratio);
  return `rgb(${blend(r)}, ${blend(g)}, ${blend(b)})`;
};

/**
 * The fill behind a grid's column headers, and behind anything meant to read as one: a washed accent, except on
 * the service portal, whose blue already has a tint of its own.
 */
export const gridHeaderBg = (palette: {
  accent?: { main?: string };
  blue?: Record<number, string>;
}): string => {
  const accentMain = palette.accent?.main || '#8E6DE1';

  return accentMain === palette.blue?.[500]
    ? (palette.blue?.[100] as string)
    : blendWithWhite(accentMain, 0.3);
};
